import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router';
import Home from './Component/Pages/Home';
import Header from './Component/Pages/Header';
import PrivateRoute from '../src/Component/OnlineTrain/Auth/PrivateRoute'
import GenAdd from './Component/OnlineTrain/Add_sub/GenAdd';
import Authendicate from './Component/OnlineTrain/Auth/Auth';
import FlashAdd from './Component/OnlineTrain/Add_sub/FlashAdd';
import SetAdd from './Component/OnlineTrain/Add_sub/SetAdd';
import Combination from './Component/OnlineTrain/Add_sub/Combination';
import GenDiv from './Component/OnlineTrain/Division/Genrator/DivGen';
import SetDiv from './Component/OnlineTrain/Division/Set/SetDiv';
import SpeedRoundDiv from './Component/OnlineTrain/Division/Speedround/SpeedRoundDiv';
import GenMul from './Component/OnlineTrain/Multiplication/Genrator/GenMul';
import SetMul from './Component/OnlineTrain/Multiplication/Set/SetMul';
import SpeedRoundMul from './Component/OnlineTrain/Multiplication/SpeedRound/SpeedRoundMul';
import Contact from './Component/Pages/contact';
import Footer from './Component/Pages/footer';

const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes className='font'>
        <Route path="/Auth" element={<Authendicate />} />
        {/* <Route path="/Auth" element={<Auth />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/additionGenrator" element={<PrivateRoute element={<GenAdd />} />} />
        <Route path="/additionFlash" element={<PrivateRoute element={<FlashAdd />} />} />
        <Route path="/additionSet" element={<PrivateRoute element={<SetAdd />} />} />
        <Route path="/nocombination" element={<PrivateRoute element={<Combination />} />} />
        <Route path="/divisonGenrator" element={<PrivateRoute element={<GenDiv />} />} />
        <Route path="/divisonSet" element={<PrivateRoute element={<SetDiv />} />} />
        <Route path="/divisonSpeedRound" element={<PrivateRoute element={<SpeedRoundDiv />} />} />
        <Route path="/multiplicationGenrator" element={<PrivateRoute element={<GenMul />} />} />
        <Route path="/multiplicationSet" element={<PrivateRoute element={<SetMul />} />} />
        <Route path="/multiplicationSpeedRound" element={<PrivateRoute element={<SpeedRoundMul />} />} />
        <Route path="/contact" element={<PrivateRoute element={<Contact />} />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
export default App
